import { useState } from "react"

import { useQuery } from "@tanstack/react-query"
import { DateTime } from "luxon"

import DateTimePicker from "@/components/DateTimePicker.tsx"
import { Label } from "@/components/ui/label.tsx"

import { getDriverData } from "../api/getDriverData.ts"

import DriverDetailTable from "./DriverDetailTable.tsx"

import type { DateRange } from "react-day-picker"

const defaultRange: DateRange = {
  from: DateTime.now().setZone("America/Chicago").startOf("month").toJSDate(),
  to: DateTime.now().setZone("America/Chicago").endOf("month").toJSDate(),
}

export default function DriverDetail() {
  const [dateRange, setDateRange] = useState<DateRange | undefined>(defaultRange)

  const { data, isPending } = useQuery({
    queryKey: ["driverData", { dateRange }],
    queryFn: () => getDriverData(dateRange),
  })

  return (
    <div className="xl:col-span-4 md:col-span-2 sm:col-span-1 flex flex-col gap-2">
      <div className="flex justify-stretch sticky top-0 gap-2 rounded-md shadow-sm border p-4 bg-card z-100">
        <div className="flex grow gap-2">
          <Label>Start:</Label>
          <DateTimePicker
            key="start"
            value={dateRange?.from}
            onChange={(v) => setDateRange({ ...dateRange, from: v })}
            className="grow"
          />
        </div>
        <div className="flex grow gap-2">
          <Label>End:</Label>
          <DateTimePicker
            key="end"
            value={dateRange?.to}
            onChange={(v) => {
              setDateRange({
                from: dateRange?.from,
                to: v,
              })
            }}
            className="grow"
          />
        </div>
      </div>
      <div className="w-full rounded-md shadow-sm border">
        <DriverDetailTable data={data || []} isLoading={isPending} />
      </div>
    </div>
  )
}
